const ETA_I18N_KEYS = {
  'available now': 'shipping.etaAvailableNow',
  'today': 'shipping.etaToday',
  'within hours': 'shipping.etaWithinHours',
  '1–3 business days': 'shipping.etaOneToThreeDays',
  '1-3 business days': 'shipping.etaOneToThreeDays',
  '2–7 business days': 'shipping.etaTwoToSevenDays',
  '2-7 business days': 'shipping.etaTwoToSevenDays',
  '4–7 business days': 'shipping.etaFourToSevenDays',
  '4-7 business days': 'shipping.etaFourToSevenDays',
  'up to 14 days': 'shipping.etaUpToFourteenDays',
};

const LABEL_I18N_KEYS = {
  'same-day': 'shipping.labelSameDay',
  'economic': 'shipping.labelEconomic',
  'standard': 'shipping.labelStandard',
  'slow': 'shipping.labelSlow',
  'pickup from shop': 'shipping.pickup',
};

export function translateShippingEta(etaCopy, t) {
  if (!etaCopy) return '';
  const lookup = ETA_I18N_KEYS[String(etaCopy).trim().toLowerCase()];
  if (lookup) return t(lookup, { defaultValue: etaCopy });
  return etaCopy;
}

export function translateShippingLabel(label, t) {
  if (!label) return '';
  const lookup = LABEL_I18N_KEYS[String(label).trim().toLowerCase()];
  if (lookup) return t(lookup, { defaultValue: label });
  return t(`checkout.shippingLabel.${String(label).replace(/\s+/g, '').toLowerCase()}`, { defaultValue: label });
}
